import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, getFormValues, isInvalid } from 'redux-form';
import { connect } from 'react-redux'
import RenderCheckbox from './RenderCheckbox';
import RenderDatePicker from './RenderDatePicker';
import $ from 'jquery';
//import moment from 'moment';
import {
  //ADD_CARD_REQUEST,
  EDIT_CARD_REQUEST,
  EDIT_CARD_SUCCESS,
  STATUS_PENDING,
  STATUS_APPROVED,
  STATUS_DECLINED,
  STATUS_RETURNED
} from '../constants/Cards';

const validate = (values) => {

    const errors = {};

    if (!values.firstName) {
        errors.firstName = 'Vaaditaan'
    }
    if (!values.lastName) {
        errors.lastName = 'Vaaditaan'
    }
    if (!values.socialSecurityNumber) {
        errors.socialSecurityNumber = 'Vaaditaan'
    }
    if (!values.telephone) {
      errors.telephone = 'Vaaditaan'
    } 
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Virheellinen sähköpostiosoite'
    }
    if (!values.streetAddress) {
        errors.streetAddress = 'Vaaditaan'
    }
    if (!values.city) {
        errors.city = 'Vaaditaan'
    }
    if (!values.postalCode) {
        errors.postalCode = 'Vaaditaan'
    } else if (values.postalCode.length !== 5 || isNaN(values.postalCode)) {
        errors.postalCode = 'Virheellinen postinumero'
    }
    if (!values.socialSecurityNumber) {
        errors.socialSecurityNumber = 'Vaaditaan'
    } else {
        const SSN_REGEX = /^(((0[1-9]|[12][0-9]|3[01])(0[13578]|10|12))|((0[1-9]|[12][0-9]|30)(0[469]|11))|(0[1-9]|[12][0-9])02)[0-9]{2}[+-A][0-9]{3}[0-9A-FHJ-NPR-Y]$/;
        const ssn = values.socialSecurityNumber.toUpperCase();

        if (ssn.match(SSN_REGEX) === null) {
            errors.socialSecurityNumber = 'Vaaditaan';
        } else {
            if(!idNumberIsValid(ssn.substring(7, 10)) || !checksumIsValid(ssn)) {
              errors.socialSecurityNumber = 'Vaaditaan';
            }
        }
    }
    if (!values.starts) {
        errors.starts = 'Vaaditaan';
    }
    const hasFixedPeriod = values.fixedPeriod === 'true' || !values.hasOwnProperty('fixedPeriod'); 
    if (hasFixedPeriod && !values.ends) {
        errors.ends = 'Vaaditaan';
    }

    if (!values.safetyTrainingCompleted) {
      errors.safetyTrainingCompleted = 'Vaaditaan';
    }

    return errors
};

const idNumberIsValid = (idNumber) => {
  idNumber = parseInt(idNumber);
  if (idNumber > 1 && idNumber < 900) {
    return true;
  }

  return false;
};

const checksumIsValid = (ssn) => {
    if (getChecksum(ssn) === ssn.charAt(ssn.length - 1)) {
        return true;
    }

    return false;
}

const getChecksum = (ssn) => {
    const mod = (ssn.substring(0, 6) + ssn.substring(7, 10)) % 31;

    if (mod >= 0 && mod <= 9) {
        return mod.toString();
    } else if (mod >= 10 && mod <= 15) {
        return String.fromCharCode(55 + mod);
    } else if (mod === 16) {
        return 'H';
    } else if (mod >= 17 && mod <= 21) {
        return String.fromCharCode(57 + mod);
    } else if (mod === 22) {
        return 'P';
    } else if (mod >= 23 && mod <= 30) {
        return String.fromCharCode(59 + mod);
    } else {
        return false;
    }
}

const isRequired = fieldName => {
  const requiredFields = [
    'firstName',
    'lastName',
    'socialSecurityNumber',
    'telephone',
    'starts',
    'streetAddress',
    'city',
    'postalCode',
  ];
  return requiredFields.some(name => name === fieldName)
}

const renderField = ({input, label, placeholder, type, readOnly, meta: {error}}) => (
  <div className={error && 'form-group has-required' || 'form-group has-success'}>
    {
      label
      ?
      <label className='upper-label'>{label}</label>
      :
      ''
    }
    <input {...input}
      type={type}
      placeholder={placeholder}
      readOnly={readOnly}
      className={readOnly ? 'form-control' :
       (error && 'form-control form-control-required' ||
        isRequired(input.name) && 'form-control form-control-success') ||
       'form-control'}
    />
  </div>
);

const renderRadio = ({input, id, val, checked, readOnly}) => {
  return (
      <input {...input}
        id={id}
        value={val}
        type='radio'
        checked={checked}
        readOnly={readOnly}
      />
  );
}


let CardForm = props => {
  const {handleSubmit, submitting, card, currentValues, saveCard, editCardTimePeriod,
         saveCardTemporarily, deleteCard, onDeleteSuccess, fetching, action, user, translations} = props;
  const adminCantEdit = user.isAdmin && (card.status === 'STATUS_APPROVED' ||
                                         card.status === 'STATUS_DECLINED');

  const approve = (e) => {
    const card = e;
    card.status = STATUS_APPROVED;

    saveCard(card);
  };

  const remove = () => {
    if (!confirm(translations['cardForm.Haluatko varmasti poistaa hakemuksen'])) {
      return;
    }

    deleteCard(card.id, user.isAdmin ? null : user.companyId)
      .then(onDeleteSuccess);
  }

  const back = (e) => {
    const card = e;
    card.status = STATUS_RETURNED;

    saveCard(card);
  };

  const decline = (e) => {
    const card = e;
    card.status = STATUS_DECLINED;

    saveCard(card);
  };

  const resend = (e) => {
    const card = e;
    card.status = STATUS_PENDING;

    saveCard(card);
  }

  const saveCardWithCompany = (e) => {
    const card = e;
    let fixedPeriod = (card.fixedPeriod === 'true');
    if (!fixedPeriod) {
      delete card.ends;
    }
    if (!user.isAdmin) {
      card.companyId = user.companyId;
      if (card.status === STATUS_RETURNED) {
        card.status = STATUS_PENDING;
      }
      saveCard(card, user.companyId);
    } else {
      saveCard(card);
    }
  };

  const storeCardTemporarily = (e) => {
    saveCardTemporarily(props.currentValues);
    handlePeriodTypeChange(e);
  }

  const handlePeriodTypeChange = (e) => {
    const fixedPeriod = (e.target.value === 'true');
    if (fixedPeriod) {
      $('#ends').show(500);
      editCardTimePeriod(true);
    } else {
      $('#ends').hide(500);
      editCardTimePeriod(false);
    }
  }

  if (!card._isInitialized) {
    if (!card.id) {
      $('#fixed-period').click();
      $('#ends').show(500);
    } else if (!card.ends) {
      $('#open-ended').click();
      $('#ends').hide(500);
    }

    card._isInitialized = true;
  } else {
    if (card.fixedPeriod === true) {
      $('#ends').show(0);
  } else if (card.fixedPeriod === false) {
      $('#ends').hide(0);
    }
  }

  return <div id='cardForm' className='modal fade'>
      <div className='modal-dialog modal-lg' role='document'>
          <div className='modal-content'>
              <form className='card-form' disabled={fetching}
                    onSubmit={!user.isAdmin ? handleSubmit(saveCardWithCompany) : ''}>

                  <Field name='id' component='hidden' value='0'/>
                  <Field name='status' component='hidden' value={STATUS_PENDING}/>
                  <div className='modal-header'>
                    <div>
                      {action === EDIT_CARD_REQUEST || action === EDIT_CARD_SUCCESS ?
                        <h4>Hakemus</h4>
                        :
                        <h4>Uusi hakemus</h4>
                      }
                      <span className='text-muted'>
                        {translations['cardForm.Lähettäjä']}: <strong>{card.appliedByName}</strong>
                      </span>
                    </div>
                      <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                          <span aria-hidden='true'>&times;</span>
                      </button>
                  </div>
                  <div className='modal-body'>
                      <div className='row'>
                        <fieldset className='col-sm-7 col-md-4 col-xl-3'>
                            <Field type='text'
                                   label={translations['cardForm.Sukunimi']}
                                   placeholder='Virtanen'
                                   name='lastName'
                                   component={renderField}
                                   readOnly={adminCantEdit}/>
                        </fieldset>
                          <fieldset className='col-sm-5 col-md-4 col-xl-3'>
                              <Field type='text'
                                     label={translations['cardForm.Etunimi']}
                                     placeholder='Matti'
                                     name='firstName'
                                     component={renderField}
                                     readOnly={adminCantEdit}/>
                          </fieldset>
                          <fieldset className='col-md-4 col-xl-3'>
                              <Field type='text'
                                     label={translations['cardForm.Henkilötunnus']}
                                     placeholder='010170-123A'
                                     name='socialSecurityNumber'
                                     component={renderField}
                                     readOnly={adminCantEdit}/>
                          </fieldset>
                      </div>
                      <div className='row'>
                          <fieldset className='col-sm-5 col-lg-4 col-xl-3'>
                              <Field type='tel'
                                     label={translations['cardForm.Puhelin']}
                                     placeholder='040 123 1234'
                                     name='telephone'
                                     component={renderField}
                                     readOnly={adminCantEdit}/>
                          </fieldset>
                          <fieldset className='col-sm-7 col-lg-6 col-xl-5'>
                              <Field type='email'
                                     label={translations['cardForm.Sähköposti']}
                                     placeholder='matti.virtanen@esimerkki.fi'
                                     name='email'
                                     component={renderField}
                                     readOnly={adminCantEdit}/>
                          </fieldset>
                      </div>

                      <hr />

                      <div className='row'>
                        <fieldset className='col-sm-5'>
                          <div className='form-group'>
                            <label className='upper-label'>{translations['cardForm.Osoite']}</label>
                            <Field name='streetAddress' component={renderField} type='text' placeholder='Kappelitie 6' readOnly={adminCantEdit}/>
                          </div>
                        </fieldset>
                        <fieldset className='col-sm-4'>
                          <div className='form-group'>
                            <label className='upper-label'>{translations['cardForm.Kaupunki']}</label>
                            <Field name='city' component={renderField} type='text' placeholder='Espoo' readOnly={adminCantEdit}/>
                          </div>
                        </fieldset>
                        <fieldset className='col-sm-3'>
                          <div className='form-group'>
                            <label className='upper-label'>{translations['cardForm.Postinumero']}</label>
                            <Field name='postalCode' component={renderField} type='text' placeholder='02200' readOnly={adminCantEdit}/>
                          </div>
                        </fieldset>
                      </div>

                      <hr />

                      {user.isAdmin && card.status !== 'STATUS_PENDING' ?

                          <div className='row'>
                            <fieldset className='col-sm-6'>
                              <div className='form-group'>
                                <label className='upper-label'>{translations['cardForm.Alkaa']}</label>
                                <Field name='starts' component={renderField} type='text' readOnly={adminCantEdit}/>
                              </div>
                            </fieldset>
                            <fieldset className='col-sm-6'>
                              <div className='form-group'>
                                <label className='upper-label'>{translations['cardForm.Päättyy']}</label>
                                <Field name='ends' component={renderField} type='text' readOnly={adminCantEdit}/>
                              </div>
                            </fieldset>
                          </div>

                          :

                          <div>
                            <fieldset className='form-group'>
                                <label className='upper-label'>{translations['cardForm.Kesto']}</label>
                                <div>
                                  <div className='btn-group'>
                                    <label className='btn btn-outline-secondary'>
                                      {/*<input type='radio' name='fixedPeriod' id='fixed-period' />*/}
                                      <Field
                                          id='fixed-period'
                                          name='fixedPeriod'
                                          component={renderRadio}
                                          val='true'
                                          checked={(card.hasOwnProperty('fixedPeriod') && card.fixedPeriod === true) ||
                                                       (!card.id && !card.hasOwnProperty('fixedPeriod'))}
                                          onChange={storeCardTemporarily}
                                      />
                                      {translations['cardForm.Määräaikainen']}
                                    </label>
                                    <label className='btn btn-outline-secondary'>
                                        {/*<input type='radio' name='fixedPeriod' id='open-ended' />*/}
                                        <Field
                                            id='open-ended'
                                            name='fixedPeriod'
                                            component={renderRadio}
                                            val='false'
                                            checked={card.hasOwnProperty('fixedPeriod') && card.fixedPeriod === false}
                                            onChange={storeCardTemporarily}
                                        />

                                        {translations['cardForm.Voimassa toistaiseksi']}
                                    </label>
                                  </div>
                                </div>
                            </fieldset>
                            <div className='row'>
                              <fieldset className='col-sm-6 form-group'>
                                <label className='upper-label'>{translations['cardForm.Alkaa']}</label>
                                <Field
                                  name='starts'
                                  type='date'
                                  className='form-control'
                                  placeholder='dd.mm.yyyy'
                                  component={RenderDatePicker}
                                />
                              </fieldset>
                              <fieldset className='col-sm-6 form-group' id='ends'>
                                <label className='upper-label'>{translations['cardForm.Päättyy']}</label>
                                <Field
                                  name='ends'
                                  type='date'
                                  className='form-control'
                                  placeholder='dd.mm.yyyy'
                                  minDate={currentValues && currentValues.starts}
                                  component={RenderDatePicker}
                                />
                              </fieldset>
                            </div>
                          </div>

                      }

                      <fieldset>
                          <Field type='textarea'
                                 label={translations['cardForm.Lisätiedot']}
                                 placeholder=''
                                 name='additionalDetails'
                                 component={renderField}
                                 readOnly={adminCantEdit}/>
                      </fieldset>

                      {(user.isAdmin || !user.isAdmin && card.operatorNotes !== undefined && card.operatorNotes.trim() !== '') &&
                          <div className='form-group'>
                              <label className='upper-label'>{translations['cardForm.Käsittelijän huomiot']}</label>
                              <Field name='operatorNotes' component={renderField} type='text' readOnly={!user.isAdmin}/>
                          </div>
                      }

                      <Field
                          name='safetyTrainingCompleted'
                          value={true}
                          checkedValue={true}
                          className={currentValues && currentValues.safetyTrainingCompleted ? null : 'has-required'}
                          component={RenderCheckbox}
                      >
                        {`${translations['cardForm.Turvallisuuskoulutus suoritettu #1']} `}
                        <a
                          href='https://www.portofhelsinki.fi/ammattilaisille/tietoa-sataman-kayttajille/turvallisuus/turvallisuusperehdytykset/'
                          target='_blank'
                          onClick={e => e.stopPropagation()}
                        >
                          {translations['cardForm.Turvallisuuskoulutus suoritettu #2']}
                          <span className='fa fa-external-link ml-1' />
                        </a>
                        {`. ${translations['cardForm.Turvallisuuskoulutus suoritettu #3']}`}
                      </Field>

                      <div className='mt-2'>
                        {translations['cardForm.permitExpirationWarning']}
                      </div>

                  </div>

                  {user.isAdmin && (card.status === 'STATUS_APPROVED' || card.status === 'STATUS_DECLINED') &&
                    <div className='modal-footer'>
                        <button
                            className='btn btn-outline-danger'
                            type='button'
                            disabled={currentValues && currentValues.deleting || fetching || submitting}
                            onClick={remove}
                        >
                            {currentValues && currentValues.deleting &&
                              <span className='fa fa-spin fa-refresh mr-1' />
                            }
                            <span className='fa fa-trash'/> {translations['cardForm.Poista']}
                        </button>
                    </div>
                  }


                  {user.isAdmin && card.status === 'STATUS_PENDING' &&
                    <div className='modal-footer'>
                        <button
                            className='btn btn-outline-danger btn-delete'
                            type='button'
                            disabled={currentValues && currentValues.deleting || fetching || submitting}
                            onClick={remove}
                        >
                            {currentValues && currentValues.deleting &&
                              <span className='fa fa-spin fa-refresh mr-1' />
                            }
                            <span className='fa fa-trash'/> {translations['cardForm.Poista']}
                        </button>
                        <button className='approve-card btn btn-success' type='submit' disabled={currentValues && currentValues.deleting || fetching || submitting}
                                onClick={handleSubmit(approve)}><span className='fa fa-check'/> Hyväksy
                        </button>
                        <button className='return-card btn btn-warning' type='submit' disabled={currentValues && currentValues.deleting || fetching || submitting}
                                onClick={handleSubmit(back)}><span className='fa fa-undo'/> Palauta
                        </button>
                        <button className='decline-card btn btn-danger' type='submit' disabled={currentValues && currentValues.deleting || fetching || submitting}
                                onClick={handleSubmit(decline)}><span className='fa fa-times'/> Hylkää
                        </button>
                    </div>
                  }

                  {user.isAdmin && card.status === 'STATUS_RETURNED' &&
                      <div className='modal-footer'>
                          <button
                            className='btn btn-outline-danger btn-delete'
                            type='button'
                            disabled={currentValues && currentValues.deleting || fetching || submitting}
                            onClick={remove}
                        >
                            {currentValues && currentValues.deleting &&
                              <span className='fa fa-spin fa-refresh mr-1' />
                            }
                            <span className='fa fa-trash'/> {translations['cardForm.Poista']}
                        </button>
                          <button className='decline-card btn btn-success' type='submit' disabled={fetching || submitting}
                                  onClick={handleSubmit(resend)}><span className='fa fa-send'/> Uudelleenlähetä
                          </button>
                      </div>
                  }
                  {/*
                  <button className='close-card-form btn' data-dismiss='modal' type='submit'
                          disabled={fetching || submitting}>Sulje
                  </button>
                  */}


                  {!user.isAdmin && (!card.status || card.status === 'STATUS_PENDING' || card.status === 'STATUS_RETURNED') &&
                    <div className='modal-footer'>
                        <button
                          className='send-card btn btn-success'
                          type='submit'
                          disabled={props.isInvalid || fetching || submitting}
                        >
                            <span className='fa fa-send'/>
                            {card.id && card.status === 'STATUS_PENDING' &&
                                ' Tallenna'
                            }

                            {card.id && card.status === 'STATUS_RETURNED' &&
                                ' Uudelleenlähetä'
                            }

                            {!card.id &&
                                ' Lähetä'
                            }
                        </button>
                        {/*
                        <button className='close-card-form btn' data-dismiss='modal' type='submit'
                                disabled={fetching || submitting}>Sulje
                        </button>
                        */}
                    </div>
                  }
                  
                  {currentValues && currentValues.deletionFailed &&
                    <div className='alert alert-danger mx-3'>
                      {translations['cardForm.Hakemuksen epäonnistunut poisto']}
                    </div>
                  }

              </form>
          </div>
      </div>
  </div>
};

CardForm.propTypes = {
  handleSubmit: PropTypes.func,
  fields: PropTypes.object,
  translations: PropTypes.object
};

CardForm = reduxForm({
  form: 'cardForm',
  enableReinitialize: true,
  validate
})(CardForm);

CardForm = connect(state => {
  return {
    initialValues: state.cards.card,
    currentValues: getFormValues('cardForm')(state),
    isInvalid: isInvalid('cardForm')(state),
  }
})(CardForm);

export default CardForm



// WEBPACK FOOTER //
// ./src/components/CardForm.js